export const GET_UNITS_BY_LOCATION_ID_REQUEST = 'GET_UNITS_BY_LOCATION_ID_REQUEST';
export const GET_UNITS_BY_LOCATION_ID_SUCCESS = 'GET_UNITS_BY_LOCATION_ID_SUCCESS';
export const GET_UNITS_BY_LOCATION_ID_FAILURE = 'GET_UNITS_BY_LOCATION_ID_FAILURE';
